import OpacityAnimation from '../../../../../../components/OpacityAnimation';
import { HistoricoReclama } from '../../../../types';
import Content from './components/Content';
import Header from './components/Header';
import { CommentContainer, ConversationWrapper, MessageBubble } from './styles';

interface IComment {
  reclamationObj: HistoricoReclama;
}

export default function Reclamation({ reclamationObj }: IComment) {
  return (
    <ConversationWrapper>
      <CommentContainer type="reclamation">
        <Header user={reclamationObj.usuario} createdAt={new Date(reclamationObj.dataGeracao)} type='reclamation' channel={reclamationObj.canal} />
        <MessageBubble type="reclamation">
          <OpacityAnimation>
            <Content text={reclamationObj.reclamacao} />
          </OpacityAnimation>
        </MessageBubble>
      </CommentContainer>

      {reclamationObj.resposta && (
        <CommentContainer type="answer">
          <Header user={reclamationObj.nomeAtendende} createdAt={new Date(reclamationObj.dataResposta)} type='answer' channel={reclamationObj.canal} />
          <MessageBubble type="answer">
            <OpacityAnimation>
              <Content text={reclamationObj.resposta || reclamationObj.reclamacao} />
            </OpacityAnimation>
          </MessageBubble>
        </CommentContainer>
      )}
    </ConversationWrapper>
  );
}
